import { Component, Inject } from '@angular/core';

import get from 'lodash/get';

import { ISitemap, SITEMAP } from 'pbc.angular';
import { ISorterConfig } from 'pbc.types';

import { KundeQuerySorterConfig } from 'fa-kt.types';
import { KundeService } from '../service';

@Component({
  selector: 'fa-kt-kunde-sorter',
  templateUrl: './kunde-sorter.component.html',
  styleUrls: ['./kunde-sorter.component.css'],
})
export class KundeSorterComponent {
  public KundeSorterConfig: ISorterConfig;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public kunde: KundeService,
  ) {
    this.KundeSorterConfig = KundeQuerySorterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update    */
    /*    update >> */
  }
}
